import { useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';

type SignInResponse = {
  localId: string;
  email: string;
  displayName: string;
  idToken: string;
  registered: boolean;
  refreshToken: string;
  expiresIn: string;
};

const signInApi = async (email: string, password: string): Promise<SignInResponse> => {
  var dbDNS = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBQ_ZJcgWHk7xH7M7G9FdS_BlLZDqC66hQ`;
  if (process.env.REACT_APP_MODE === 'dev') {
    dbDNS = 'http://127.0.0.1:9099/identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyBQ_ZJcgWHk7xH7M7G9FdS_BlLZDqC66hQ';
  }

  const response = await fetch(dbDNS, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password, returnSecureToken: true }),
  });
  if (!response.ok) {
    const errorJson = JSON.parse(await response.text());
    console.log('<<<<<<<<', errorJson.error.message);

    throw new Error(errorJson.error.message);
  }
  const now = new Date();
  let time = now.getTime();
  time += 3600 * 1000;
  now.setTime(time);
  const data = await response.json();
  Cookies.set('token', data.idToken, { expires: now });
  return data;
};

export const useSignInQuery = (email: string, password: string, emailAndPasswordValid: boolean) => {
  const signIn = useQuery({
    queryKey: ['signIn', { email, password }],
    queryFn: () => signInApi(email, password),
    enabled: emailAndPasswordValid,
    retry: false,
  });
  return signIn;
};
